import ReactDatePicker from "react-datepicker";
import WOSupplierRate from "./WOSupplierRate";
import AttachmentCard from "../../components/common/AttachmentCard";
import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Col,
  FormControl,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
} from "react-bootstrap";
import { ATTACHMENTS } from "../../constant/CommonInitialvalue";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPMSDropdown,
  getPMSCompletionLocation,
} from "../../features/pmsSlice";
import { fetchUserApi } from "../../features/userSlice";
import { fetchPortApi } from "../../features/portSlice";
import {
  addAttach,
  deleteAttachment,
  removeAttach,
} from "../../features/attachmentsSlice";
import { FaTrashAlt } from "react-icons/fa";
import { nanoid } from "@reduxjs/toolkit";
import { toBase64 } from "../../helper/Support";
import { commonPayloadFields } from "../../helper/storage";
import { hasPermission } from "../../helper/permissions";

function WOCompletion(props) {
  const { poId, state, setState } = props;
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const image_ref = useRef();

  const { supplier_rating_id, maintenanceDetail, repository } = useSelector(
    (state) => state.root.WO.orderDetails
  );

  const port_name_option = useSelector((state) =>
    state.root.port.list.map((el) => (
      <option key={el.id} value={el.port_name}>
        {el.port_name}
      </option>
    ))
  );
  const completed_by_option = useSelector((state) =>
    state.root.PMS.fields.completed_by.map((el) => (
      <option key={el.id} value={el.id}>
        {el.typename}
      </option>
    ))
  );
  const location_option = useSelector((state) =>
    state.root.PMS.pms_complete_location.map((el) => (
      <option key={el.id} value={el.typename}>
        {el.typename}
      </option>
    ))
  );

  const { Process } = useSelector((state) => state.root.login.loginDemo);
  const permissions = Process.find(
    (v) => v.menuname === "Purchase" && v.modulename === "WO Completion"
  );

  const attachment_list = useSelector((state) =>
    state.root.ATTACHMENT.repository.map((el) => (
      <li key={el.nanoID} className="d-flex flex-row">
        <div className="textOverflow">{el.filename}</div>
        <span
          className="text-danger"
          role="presentation"
          onClick={() => {
            dispatch(removeAttach(el.nanoID));
          }}
        >
          <FaTrashAlt />
        </span>
      </li>
    ))
  );

  useEffect(() => {
    const pmsDropdown = dispatch(fetchPMSDropdown());
    dispatch(fetchUserApi());
    dispatch(getPMSCompletionLocation());
    dispatch(fetchPortApi());
    maintenanceDetail?.length > 0
      ? setState({
          ...state,
          ...maintenanceDetail[0],
          repository,
          completion_date: new Date(`${maintenanceDetail[0].completion_date}Z`),
        })
      : setState({ ...state, head_id: poId });
    return () => {
      pmsDropdown.abort();
    };
  }, [maintenanceDetail]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleAttachment = (e) => {
    const files = e.target.files[0];
    toBase64(files).then((res) => {
      dispatch(
        addAttach({
          ...ATTACHMENTS,
          trans_id: 0,
          format: files.type,
          attachment: res,
          module: "PMS",
          screen: "WORKORDER",
          filename: files.name,
          isdisabled: "N",
          ...commonPayloadFields,
          nanoID: nanoid(),
        })
      );
    });
  };

  const onDeleteFile = (x) => {
    const payload = {
      id: x,
      module: "PMS",
      screen: "WORKORDER",
      trans_id: 0,
    };
    dispatch(deleteAttachment({ payload }))
      .unwrap()
      .then((r) => {
        props.repositoryReset();
      });
  };

  const handleShow = () => setShow(!show);

  return (
    <>
      <WOSupplierRate show={show} handleShow={handleShow} />
      {hasPermission("add", permissions?.permission) && (
        <Row>
          <Col md={12} className="d-flex justify-content-end">
            <Button
              onClick={() => handleShow()}
              className={`btn btn-primary ${
                supplier_rating_id ? "btnApprove " : "btnSave"
              }`}
            >
              Supplier&nbsp;Rating
            </Button>
          </Col>
        </Row>
      )}

      <Row className="d-flex align-items-center mb-1">
        <Col md={3}>
          <FormLabel>Completion Details</FormLabel>
        </Col>
        <Col md={9}>
          <hr />
        </Col>
      </Row>

      <Row className="mb-2">
        <Col md={3}>
          <FormGroup>
            <FormLabel className="text-muted label-grey">
              Completion Date<span className="text-danger">*</span>
            </FormLabel>
            <ReactDatePicker
              className="form-control content-grey"
              selected={state.completion_date}
              onChange={(val) => setState({ ...state, completion_date: val })}
              dateFormat="dd/MM/yyyy"
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <FormLabel className="text-muted label-grey">
              Location<span className="text-danger">*</span>
            </FormLabel>
            <FormSelect
              className={"content-grey"}
              name={"location"}
              value={state.location}
              onChange={(e) => {
                handleInputChange(e);
              }}
            >
              <option>select</option>
              {location_option}
            </FormSelect>
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <FormLabel className="text-muted label-grey">
              Port Name<span className="text-danger">*</span>
            </FormLabel>
            <FormSelect
              className={"content-grey"}
              name={"port_name"}
              value={state.port_name}
              onChange={(e) => handleInputChange(e)}
              disabled={state.location === "PORT" ? false : true}
            >
              <option value="">select</option>
              {port_name_option}
            </FormSelect>
          </FormGroup>
        </Col>

        <Col md={3}>
          <FormGroup>
            <FormLabel className="text-muted label-grey">
              Completed By<span className="text-danger">*</span>
            </FormLabel>
            <FormSelect
              className={"content-grey"}
              name={"completed_by"}
              value={state.completed_by}
              onChange={(e) => handleInputChange(e)}
            >
              <option>select</option>
              {completed_by_option}
            </FormSelect>
          </FormGroup>
        </Col>
      </Row>
      <Row className="mb-2 align-items-center">
        <Col md={3}>
          <FormGroup>
            <FormLabel className="text-muted label-grey">
              Remarks<span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              className={"content-grey"}
              name={"remarks"}
              value={state.remarks}
              onChange={(e) => handleInputChange(e)}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <FormLabel className="text-muted label-grey">
              Service done detail<span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              className={"content-grey"}
              name={"service_detail"}
              value={state.service_detail}
              onChange={(e) => handleInputChange(e)}
            />
          </FormGroup>
        </Col>

        <Col md={3}>
          <FormGroup>
            <FormLabel className="text-muted label-grey">
              Defect details<span className="text-danger">*</span>
            </FormLabel>
            <FormControl
              className={"content-grey"}
              name={"defect_details"}
              value={state.defect_details}
              onChange={(e) => handleInputChange(e)}
            />
          </FormGroup>
        </Col>
      </Row>

      <Row className="mt-3 mb-3">
        <Col md={4}>
          <input
            type="file"
            style={{ display: "none" }}
            ref={image_ref}
            onChange={(e) => handleAttachment(e)}
          />
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div
            className={"attachment-label"}
            onClick={() => {
              image_ref.current.click();
            }}
          >
            Attachments <span className="text-danger">*</span>
          </div>
          <AttachmentCard
            repositoryList={state?.repository}
            attachment_list={attachment_list}
            onDeleteFile={onDeleteFile}
          />
        </Col>
      </Row>
    </>
  );
}

export default WOCompletion;
